<template>
  <base-layout>
    <template v-slot:header>
      <div class="top-title" v-if="activityInfo.activity_status === 2">
        <div class="title-main">征稿期已结束</div>
        <div class="title-sub">感谢您对学而思网校活动的关注</div>
      </div>
      <div class="top-title" v-if="activityInfo.activity_status === 3">
        <div class="title-sub" v-if="activityInfo.rematch_status === 1">恭喜您已入围复选</div>
        <div class="title-sub" v-else>很遗憾您未进入复选</div>
      </div>
      <div class="top-title4" v-if="activityInfo.activity_status === 4">
        <div class="title-sub" v-if="activityInfo.finals_status === 1">恭喜您在决胜中获奖</div>
        <div class="title-sub" v-else>很遗憾您未在决胜中获奖</div>
      </div>
    </template>
    <Periods :period="activityInfo.period" :activityStatus="activityInfo.activity_status" tip="感谢您的关注 | 期待您的更多精彩表现"/>
    <template v-slot:footer>
      <CommonProcess/>
    </template>
  </base-layout>
</template>
<script>
import BaseLayout from '../common/baseLayout'
import Periods from '../common/periods'
// import Button from '../common/button'
import CommonProcess from '../common/commonProcess'
// import { Dialog } from 'vant'
// import eventBus from '@/summerCamp/utils/bus'

export default {
  name: 'notRegistered',
  components: {
    BaseLayout,
    Periods,
    // Button,
    CommonProcess
  },
  props: {
    activityInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    topicInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.container {
  .top-title,
  .top-title3,
  .top-title4 {
    padding-top: 14px;
    padding-bottom: 26px;
    text-align: center;

    .title-main {
      font-size: 28px/2;
      color: #666;
    }

    .title-sub {
      font-size: 34px/2;
      font-weight: 500;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #666;
    }

    & /deep/ .btn-wrapper {
      margin-top: 16%;
    }
  }

  .top-title3,
  .top-title4 {
    padding-top: 18px;
    padding-bottom: 30px;
  }

  .periods-wrapper {
    box-sizing: border-box;
    width: 90%;
    margin: 0 auto;

    ul {
      display: flex;
      overflow-x: auto;
      white-space: nowrap;

      li {
        flex: 1;
      }
    }

    .desc {
      text-align: center;
    }
  }
}
</style>
<style>
.van-dialog__header {
  color: #333 !important;
}
</style>
